import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

const GetSkillLevels = ():{ skillLevels: ILabelValuePair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelValuePair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ILabelValuePair[], AxiosError>('/EmployeeInfo/GetSkillLevels',
    (url) => fetcher(url));

  return {
    skillLevels: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetSkillLevels;
